import React from 'react';
import PropTypes from 'prop-types';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Dialog from '@material-ui/core/Dialog';
import Link from '@material-ui/core/Link';
import Button from '@material-ui/core/Button';

export default function GetADemoDialog(props) {
  const { onClose, open } = props;

  function handleClose() {
    onClose();
  }

  return (
    <Dialog onClose={handleClose} aria-labelledby="simple-dialog-title" open={open}>
      <DialogTitle id="simple-dialog-title">Get A Demo</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          We’re committed to your privacy. Episource uses the information you provide to us to
          contact you about our relevant content, products, and services. You may unsubscribe from
          these communication at any time. For more information, check out our{' '}
          <Link href="/" title="Privacy Policy">
            Privacy Policy.
          </Link>
        </DialogContentText>
        <Button
          target="_blank"
          href="https://www.episource.com/contact/"
          variant="contained"
          color="primary"
        >
          Request a Meeting
        </Button>
      </DialogContent>
    </Dialog>
  );
}

GetADemoDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};
